import { updateChangeControl } from 'src/modules/SpaceAssignment/ChangeControl/store'

const pickSubmitChangeControl = (id, payload) => {
  return async (dispatch, store) => {
    await dispatch(updateChangeControl({ id, payload }, store))
  }
}
export default pickSubmitChangeControl
